<template>
    <div id="app">
      <div class="hover-target" @mouseover="showTooltip" @mouseleave="hideTooltip">
        悬停我
        <div v-if="isTooltipVisible" class="tooltip">
          这是悬浮框内容
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        isTooltipVisible: false,
      };
    },
    methods: {
      showTooltip() {
        this.isTooltipVisible = true;
      },
      hideTooltip() {
        this.isTooltipVisible = false;
      },
    },
  };
  </script>
  
  <style>
  .hover-target {
    position: relative;
    display: inline-block;
    padding: 10px;
    background-color: #f0f0f0;
    border: 1px solid #ccc;
    cursor: pointer;
  }
  
  .tooltip {
    position: absolute;
    bottom: 100%; /* 悬浮框在目标元素上方 */
    left: 50%;
    transform: translateX(-50%);
    background-color: rgba(0, 0, 0, 0.75);
    color: white;
    padding: 5px;
    border-radius: 4px;
    white-space: nowrap;
    margin-bottom: 5px;
    z-index: 1000;
  }
  </style>